import classnames from "classnames";
import capitalize from "lodash/capitalize";
import {useState} from "react";

import {Card} from "@/components/card/Card.tsx";
import {NavTabs} from "@/components/navTabs/NavTabs.tsx";
import {HistoryTab} from "@/pages/pagespeed/report/body/history/HistoryTab.tsx";
import {PerformanceTab} from "@/pages/pagespeed/report/body/performance/PerformanceTab.tsx";
import {StructureTab} from "@/pages/pagespeed/report/body/structure/StructureTab.tsx";
import {SummaryTab} from "@/pages/pagespeed/report/body/SummaryTab.tsx";
import {WaterfallTab} from "@/pages/pagespeed/report/body/waterfall/WaterfallTab.tsx";
import {PageSpeedTab} from "@/pages/pagespeed/report/types.ts";
import {NetworkStep, PagespeedLHR} from "@/pages/pagespeed/types.ts";

import "./PSReportBody.css";

interface PSReportBodyProps {
  lhr: PagespeedLHR;
  networkSteps: NetworkStep[];
  checkID: number;
}
export const PSReportBody = ({lhr, checkID, networkSteps}: PSReportBodyProps) => {
  const [activeTab, setActiveTab] = useState<PageSpeedTab>(PageSpeedTab.SUMMARY);
  return (
    <Card variant="white" className="report-body row mt-4">
      <NavTabs
        variant="pagespeed"
        items={[
          {title: capitalize(PageSpeedTab.SUMMARY), id: PageSpeedTab.SUMMARY},
          {title: capitalize(PageSpeedTab.PERFORMANCE), id: PageSpeedTab.PERFORMANCE},
          {title: capitalize(PageSpeedTab.STRUCTURE), id: PageSpeedTab.STRUCTURE},
          {title: capitalize(PageSpeedTab.WATERFALL), id: PageSpeedTab.WATERFALL},
          {title: capitalize(PageSpeedTab.HISTORY), id: PageSpeedTab.HISTORY},
        ]}
        selectedId={activeTab}
        selectTab={(t) => setActiveTab(t as PageSpeedTab)}
      />
      <div className="tab-content px-4">
        <div
          id="tab-summary"
          className={classnames("tab-pane fade d-print-block", {
            "show active": activeTab === PageSpeedTab.SUMMARY,
          })}
        >
          <SummaryTab lhr={lhr} />
        </div>
        <div
          id="tab-performance"
          className={classnames("tab-pane fade d-print-block", {
            "show active": activeTab == PageSpeedTab.PERFORMANCE,
          })}
        >
          <PerformanceTab lhr={lhr} steps={networkSteps} />
        </div>
        <div
          id="tab-structure"
          className={classnames("tab-pane fade d-print-block", {
            "show active": activeTab == PageSpeedTab.STRUCTURE,
          })}
        >
          <StructureTab lhr={lhr} />
        </div>
        <div
          id="tab-waterfall"
          className={classnames("tab-pane fade d-print-block", {
            "show active": activeTab == PageSpeedTab.WATERFALL,
          })}
        >
          <WaterfallTab network={networkSteps} />
        </div>
        <div
          id="tab-history"
          className={classnames("tab-pane fade d-print-block", {
            "show active": activeTab == PageSpeedTab.HISTORY,
          })}
        >
          <HistoryTab checkID={checkID} lhr={lhr} />
        </div>
      </div>
    </Card>
  );
};
